<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-card-title>
        <span class="headline">Bolões</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-3" dark @click="onClickSettings()"
          >Configurações</v-btn
        >
        <v-btn color="primary" dark @click="incluirBolao()">Incluir</v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="2">
            <v-select
              :items="tipos"
              label="Tipo"
              item-text="label"
              item-value="value"
              required
              v-model="filtro.tipo"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.numeroConcurso"
              label="Número concurso"
              type="number"
            ></v-text-field>
          </v-col>

          <v-col cols="4">
            <v-radio-group v-model="filtro.status" row>
              <v-radio label="Ativos" value="A"></v-radio>
              <v-radio label="Encerrados" value="E"></v-radio>
              <v-radio label="Todas" value="T"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col v-if="filtro.status == 'E'" cols="2">
            <v-select
              v-if="filtro.tipo == 'sena'"
              :items="pontosAcertadosFiltroSena"
              label="Pontos Acertados"
              item-text="label"
              item-value="value"
              required
              v-model="filtro.pontosAcertatados"
            ></v-select>
            <v-select
              v-else-if="filtro.tipo == 'loto'"
              :items="pontosAcertadosFiltroLotoFacil"
              label="Pontos Acertados"
              item-text="label"
              item-value="value"
              required
              v-model="filtro.pontosAcertatados"
            ></v-select>
          </v-col>
          <v-col style="padding-top: 25px;" cols="1">
            <v-btn color="primary" dark @click="getDadosBolao()">Filtrar</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :key="boloesKey"
          :headers="headers"
          :items="boloes"
          :items-per-page="10"
          :loading="loading"
          :no-data-text="
            loading ? 'Carregando' : 'Nenhum Registro para mostrar'
          "
          class="elevation-1"
        >
          <template v-slot:[`item.datainicio`]="{ item }">
            <span>{{ formatDate(item.datainicio) }}</span>
          </template>
          <template v-slot:[`item.datafinal`]="{ item }">
            <span>{{ formatDate(item.datafinal) }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span>{{ item.status == "A" ? "Ativo" : "Encerrado" }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <span style="margin-right: 10px;">
              <v-icon small @click="editItem(item)">edit</v-icon></span
            >
            <span>
              <v-icon small @click="deleteItem(item)">delete</v-icon></span
            >
          </template>
        </v-data-table>

        <v-dialog v-model="dialogSettings" persistent max-width="1200">
          <v-card class="card-rounded">
            <v-form
              @submit.prevent="onSave"
              ref="settingsBolaoForm"
              lazy-validation
            >
              <v-card-title>
                Configurações
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col pl-3 pr-3 cols="6" xl="6" lg="6" md="12" sm="12">
                    <v-col pl-3 pr-3 style="border: solid 1px;" cols="12">
                      <span>Bolão com 15 números</span>
                      <v-row>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio11_bolao15"
                            label="11 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio12_bolao15"
                            label="12 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio13_bolao15"
                            label="13 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col> </v-col
                  ><v-col pl-3 pr-3 cols="6" xl="6" lg="6" md="12" sm="12">
                    <v-col pl-3 pr-3 style="border: solid 1px;" cols="12">
                      <span>Bolão com 16 números</span>
                      <v-row>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio11_bolao16"
                            label="11 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio12_bolao16"
                            label="12 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio13_bolao16"
                            label="13 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col pl-3 pr-3 cols="6" xl="6" lg="6" md="12" sm="12">
                    <v-col pl-3 pr-3 style="border: solid 1px;" cols="12">
                      <span>Bolão com 17 números</span>
                      <v-row>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio11_bolao17"
                            label="11 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio12_bolao17"
                            label="12 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio13_bolao17"
                            label="13 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col pl-3 pr-3 cols="6" xl="6" lg="6" md="12" sm="12">
                    <v-col pl-3 pr-3 style="border: solid 1px;" cols="12">
                      <span>Bolão com 18 números</span>
                      <v-row>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio11_bolao18"
                            label="11 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio12_bolao18"
                            label="12 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio13_bolao18"
                            label="13 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col pl-3 pr-3 cols="6" xl="6" lg="6" md="12" sm="12">
                    <v-col pl-3 pr-3 style="border: solid 1px;" cols="12">
                      <span>Bolão com 19 números</span>
                      <v-row>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio11_bolao19"
                            label="11 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio12_bolao19"
                            label="12 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio13_bolao19"
                            label="13 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col pl-3 pr-3 cols="6" xl="6" lg="6" md="12" sm="12">
                    <v-col pl-3 pr-3 style="border: solid 1px;" cols="12">
                      <span>Bolão com 20 números</span>
                      <v-row>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio11_bolao20"
                            label="11 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio12_bolao20"
                            label="12 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          class="pt-0 pb-0"
                          cols="4"
                          xl="4"
                          lg="4"
                          md="12"
                          sm="12"
                        >
                          <v-text-field
                            v-model="configuracoesBolao.premio13_bolao20"
                            label="13 números"
                            required
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>
                <span
                  >Variáveis: [numero], [hora], [dataInicial], [dataFinal],
                  [tipo], [valor], [qtdemaxquotas], [qtdenumeroaposta],
                </span>
                <br />
                <v-textarea
                  v-model="configuracoesBolao.regras"
                  label="Regras"
                  outlined
                  rows="8"
                >
                </v-textarea>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogSettings = false"
                  >Fechar</v-btn
                >
                <v-btn color="blue darken-1" text @click="onSaveSettings"
                  >Salvar</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="1200">
          <v-card class="card-rounded">
            <v-form @submit.prevent="onSave" ref="bolaoForm" lazy-validation>
              <v-card-title>
                Bolão
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="tab">
                  <v-tab :key="'tab1'">
                    Dados
                  </v-tab>
                  <v-tab :key="'tab2'">
                    Números
                  </v-tab>
                  <v-tab :key="'tab3'">
                    Compras Usuários
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item :key="'tab1'">
                    <v-card flat>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                            <v-select
                              :items="tipos"
                              label="Tipo"
                              item-text="label"
                              item-value="value"
                              :rules="tipoRules"
                              required
                              v-model="bolao.tipo"
                              :disabled="bolao.id != null"
                            ></v-select>
                          </v-col>
                          <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.numeroconcursoloteria"
                              label="Número Loteria"
                              type="number"
                              required
                              :disabled="bolao.id != null"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.numeroconcurso"
                              label="Referência"
                              :rules="numeroRules"
                              required
                              :disabled="bolao.id != null"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-text-field
                              v-model="configuracoesBolao.sequencial"
                              label="Sequencial do Bolão"
                              disabled
                              required
                              :loading="loadingSettings"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                            <v-select
                              :items="bolaoStatus"
                              label="Status"
                              item-text="label"
                              item-value="value"
                              :rules="statusRules"
                              required
                              v-model="bolao.status"
                            ></v-select>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.qtdebolaoaleatorio"
                              label="Quantidade Bolões"
                              :rules="qtdeBoloesRules"
                              required
                              :disabled="bolao.id != null"
                              v-on:blur="getTodosBoloesArmazenados()"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-row>
                              <v-col cols="6">
                                <v-switch
                                  :key="bolaoManualKey"
                                  v-model="bolao.bolaomanual"
                                  class="ma-2"
                                  label="Combo"
                                  :disabled="bolao.id != null"
                                ></v-switch>
                              </v-col>
                              <v-col cols="6">
                                <v-switch
                                  :key="bolaosupremoKey"
                                  v-model="bolao.supremo"
                                  class="ma-2"
                                  label="Supremo"
                                  :disabled="bolao.id != null"
                                ></v-switch>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.percentualsupremo"
                              label="Percentual Bolão Supremo"
                              :rules="percSupremoRules"
                              type="number"
                              required
                              :disabled="bolao.id != null"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.minimonumerosupremo"
                              label="Minimo de numeros"
                              :rules="minimoSupremoRules"
                              type="number"
                              required
                              :disabled="bolao.id != null"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="7" xl="7" lg="7" md="12" sm="12">
                            <v-row>
                              <v-col cols="6" xl="6" lg="6" md="6" sm="6">
                                <v-text-field
                                  v-model="bolao.valor"
                                  label="Valor em R$"
                                  type="number"
                                  :rules="valorRules"
                                  required
                                  :disabled="bolao.id != null"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="6" xl="6" lg="6" md="6" sm="6">
                                <v-text-field
                                  v-model="bolao.qtdemaxquotas"
                                  label="Qtde máxima de quotas"
                                  type="number"
                                  :rules="qtdeQuotasRules"
                                  required
                                  :disabled="bolao.id != null"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="4" xl="4" lg="4" md="4" sm="4">
                                <v-text-field
                                  v-model="dtInicial"
                                  v-mask="'##/##/####'"
                                  label="Data Inicial"
                                  :rules="dtInicioRules"
                                  :disabled="bolao.id != null"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="4" xl="4" lg="4" md="4" sm="4">
                                <v-text-field
                                  v-model="dtFinal"
                                  v-mask="'##/##/####'"
                                  label="Data Final"
                                  :rules="dtfinalRules"
                                  :disabled="bolao.id != null"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="4" xl="4" lg="4" md="4" sm="4">
                                <v-text-field
                                  v-model="bolao.horalimite"
                                  v-mask="'##:##'"
                                  label="Hora Limite"
                                  :rules="horaLimiteRules"
                                  :disabled="bolao.id != null"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="6" xl="6" lg="6" md="6" sm="6">
                                <v-text-field
                                  v-model="bolao.qtdenumeroaposta"
                                  label="Qtde nº na Aposta"
                                  type="number"
                                  required
                                  :rules="qtdeNumerosRules"
                                  :disabled="bolao.id != null"
                                  v-on:blur="getTodosBoloesArmazenados()"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="6" xl="6" lg="6" md="6" sm="6">
                                <v-text-field
                                  v-model="bolao.apostasefetivadas"
                                  label="Qtde Apostas Efetivadas"
                                  type="number"
                                  disabled
                                  required
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="5" xl="5" lg="5" md="12" sm="12">
                            <v-textarea
                              v-model="bolao.regras"
                              label="Regras"
                              outlined
                              readonly
                              rows="9"
                              :loading="loadingSettings"
                            >
                            </v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                            <v-select
                              :items="concursos"
                              label="Concurso"
                              item-text="numero"
                              return-object
                              required
                              v-model="concursoSelecionado"
                              @change="onChangeConcurso($event)"
                              :disabled="
                                bolao.id == null || bolao.status == 'A'
                              "
                            ></v-select>
                          </v-col>
                          <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                            <v-switch
                              :key="premiadoKey"
                              v-model="bolao.premiado"
                              class="ma-2"
                              label="Bolão Premiado"
                              :disabled="
                                bolao.id == null || bolao.status == 'A'
                              "
                            ></v-switch>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.valortotalpremio"
                              label="Valor Total do Prêmio"
                              type="number"
                              required
                              :key="bolaoPremioKey"
                              :rules="valorTotalPremioRules"
                              :disabled="
                                bolao.id == null || bolao.status == 'A'
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                            <v-text-field
                              v-model="bolao.valorpremioaposta"
                              label="Prêmio por Aposta"
                              type="number"
                              required
                              :key="bolaoPremioKey"
                              :disabled="
                                bolao.id == null || bolao.status == 'A'
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                            <v-select
                              v-if="bolao.tipo == 'sena'"
                              :items="pontosAcertadosSena"
                              label="Pontos Acertados"
                              item-text="label"
                              item-value="value"
                              required
                              v-model="bolao.pontosacertados"
                              :disabled="
                                bolao.id == null || bolao.status == 'A'
                              "
                            ></v-select>
                            <v-select
                              v-else-if="bolao.tipo == 'loto'"
                              :items="pontosAcertadosLotoFacil"
                              label="Pontos Acertados"
                              item-text="label"
                              item-value="value"
                              required
                              v-model="bolao.pontosacertados"
                              :disabled="
                                bolao.id == null || bolao.status == 'A'
                              "
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item :key="'tab2'">
                    <v-card flat>
                      <v-card-title>
                        
                        <v-radio-group v-model="combinacoesArmazenadas" row>
                          <v-radio label="Combinações Salvas" :value=true></v-radio>
                          <v-radio label="Gerar novas Combinações" :value=false></v-radio>
                        </v-radio-group>
                        
                        
                        <v-spacer></v-spacer>

                        <v-btn v-if="!combinacoesArmazenadas"
                          color="blue darken-1"
                          text
                          @click="gerarCombinacoes"
                          >Gerar Combinações</v-btn
                        >
                      </v-card-title>
                      <v-card-text>
                        <v-container >
                          <v-row v-if="!combinacoesArmazenadas && combinacoesGeradas">                            
                            <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                              <v-text-field
                                v-model="nomeCombinacao"
                                label="Descricao Combinação"
                                required
                                :disabled="bolao.id != null"
                              ></v-text-field>
                            </v-col>

                            <v-btn 
                          class="mt-5"
                              color="blue darken-1"
                              text
                              @click="salvarBolaoArmazenado"
                              >Salvar Combinações</v-btn
                            >
                          </v-row>
                          <v-row v-if="combinacoesArmazenadas">
                            <v-col cols="3">
                              <v-text-field
                                    v-model="bolaoArmazenadoFiltro"
                                    label="Descrição Bolão Armazenado"
                                    required
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                          <v-btn
                          class="mt-5"
                            color="blue darken-1"
                            text
                            @click="buscarBoloesArmazenados"
                            >Buscar</v-btn
                          >
                          </v-col>

                          <v-col cols="3">
                            <v-select
                              :items="boloesArmazenados"
                              label="Bolão armazenado"
                              item-text="descricao"
                              item-value="value"
                              return-object
                              :loading=loading
                              required
                              @change="onChangeBolaoArmazenado($event)"
                            ></v-select>
                          </v-col>
                            </v-row>
                            <v-row>
                              <div
                                v-for="b in bolao.numeros"
                                :key="b.sequencialbolao"
                              >
                                <v-col cols="12">
                                  <v-input
                                    >{{ bolao.numeroconcurso }}
                                    {{ b.sequencialbolao }}</v-input
                                  >
                                </v-col>
                                <v-col cols="12">
                                  <number-selector
                                    :key="b.sequencialbolao"
                                    v-model="b.numeros"
                                    :qtde="bolao.tipo == 'loto' ? 25 : 60"
                                  ></number-selector>
                                </v-col>
                              </div>
                            </v-row>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item :key="'tab3'">
                    <v-card flat>
                      <v-data-table
                        :key="comprasKey"
                        :headers="headersUsers"
                        :items="comprasUsers"
                        :items-per-page="10"
                        :loading="loading"
                        :no-data-text="
                          loading
                            ? 'Carregando'
                            : 'Nenhum Registro para mostrar'
                        "
                        class="elevation-1"
                      >
                        <template v-slot:[`item.status`]="{ item }">
                          <span>{{
                            item.status == "C" ? "Confirmado" : "Pendente"
                          }}</span>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false"
                  >Fechar</v-btn
                >
                <v-btn color="blue darken-1" text @click="onSave">Salvar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <app-delete-dialog
          msg="Deseja Remover o bolão selecionado?"
          :dialogDelete="deleteDialog"
          :id="selectedId"
          @onConfirmDelete="onConfirmDelete($event)"
          @onCancelDelete="deleteDialog = false"
        ></app-delete-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import DatePicker from "../../components/date-picker.vue";
import NumberSelector from "../../components/number-selector.vue";
import DeleteDialog from "@/views/delete/DeleteDialog";
import { mask } from "vue-the-mask";
import Util from "../../service/util-service";

export default {
  components: {
    "date-picker": DatePicker,
    "number-selector": NumberSelector,
    "app-delete-dialog": DeleteDialog,
  },
  directives: { mask },
  data() {
    return {
      filtro: { status: "A", tipo: "loto" },
      tab: null,
      editedBolao: null,
      bolao: {},
      boloes: [],
      concursos: [],
      concursoSelecionado: {},
      configuracoesBolao: {},
      boloesArmazenados: [],
      bolaoArmazenadoFiltro: null,
      bolaoArmazenadoSelecionado: null,
      comprasUsers: [],
      dialog: false,
      deleteDialog: false,
      dialogSettings: false,
      combinacoesArmazenadas: true,
      combinacoesGeradas: false,
      selectedId: 0,
      dtkey: 0,
      dtfkey: 0,
      premiadoKey: 0,
      bolaoManualKey: 0,
      bolaosupremoKey: 0,
      numberSelectorKey: 0,
      numerosSorteados: [],
      comprasKey: 0,
      boloesKey: 0,
      bolaoPremioKey: 0,
      numeroRules: null,
      numeroLoteriaRules: null,
      tipoRules: null,
      statusRules: null,
      qtdeBoloesRules: null,
      percSupremoRules: null,
      minimoSupremoRules: null,
      nomeCombinacao: null,
      valorRules: null,
      qtdeQuotasRules: null,
      dtInicioRules: null,
      dtfinalRules: null,
      horaLimiteRules: null,
      qtdeNumerosRules: null,
      valorTotalPremioRules: null,
      dtInicial: "",
      dtFinal: "",
      tipoFiltro: "loto",
      filtroPontosAcertatados: null,
      pontosAcertadosFiltroSena: [
        { value: null, label: "Todos" },
        { value: 4, label: "Prêmio quadra" },
        { value: 5, label: "Prêmio quina" },
        { value: 6, label: "Prêmio sena" },
      ],
      pontosAcertadosSena: [
        { value: 4, label: "Prêmio quadra" },
        { value: 5, label: "Prêmio quina" },
        { value: 6, label: "Prêmio sena" },
      ],
      pontosAcertadosLotoFacil: [
        { value: 11, label: "Prêmio com 11 números" },
        { value: 12, label: "Prêmio com 12 números" },
        { value: 13, label: "Prêmio com 13 números" },
        { value: 14, label: "Prêmio com 14 números" },
        { value: 15, label: "Prêmio com 15 números" },
      ],
      pontosAcertadosFiltroLotoFacil: [
        { value: null, label: "Todos" },
        { value: 11, label: "Prêmio com 11 números" },
        { value: 12, label: "Prêmio com 12 números" },
        { value: 13, label: "Prêmio com 13 números" },
        { value: 14, label: "Prêmio com 14 números" },
        { value: 15, label: "Prêmio com 15 números" },
      ],

      tipos: [
        { value: "sena", label: "Mega Sena" },
        { value: "loto", label: "Loto Fácil" },
      ],
      bolaoStatus: [
        { value: "A", label: "Ativo" },
        { value: "E", label: "Encerrado" },
      ],
      headersUsers: [
        {
          text: "Nome",
          align: "left",
          sortable: true,
          value: "nome",
        },
        {
          text: "E-mail",
          align: "left",
          sortable: true,
          value: "email",
        },
        {
          text: "Telefone",
          align: "left",
          sortable: true,
          value: "telefone",
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "status",
        },
      ],
      headers: [
        { text: "", value: "actions", sortable: false },
        {
          text: "Número",
          align: "left",
          sortable: true,
          value: "numeroconcurso",
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "status",
        },
        {
          text: "Data Início",
          align: "left",
          sortable: true,
          value: "datainicio",
        },
        {
          text: "Data fim",
          align: "left",
          sortable: true,
          value: "datafinal",
        },
      ],
      loading: false,
      loadingSettings: false,
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.getSettingsBolao();
        if (this.editedBolao) {
          this.bolao = { ...this.editedBolao };
          if (this.bolao.status == "EP") {
            this.bolao.status = "E";
          }
          this.bolao.numeros;
          this.comprasKey += 1;
          this.getDadosUsuarios(this.bolao.id);
          this.getConcursos();
          this.dtInicial = Util.dateFormat(this.bolao.datainicio);
          this.dtFinal = Util.dateFormat(this.bolao.datafinal);
          if (this.editedBolao.numeros) {
            this.bolao.numeros = [];
            const groupedNumeros = this.groupBy(
              this.editedBolao.numeros,
              (n) => n.sequencialbolao
            );

            let arr = Array.from(groupedNumeros.entries());
            for (var i = 0; i < arr.length; i++) {
              const grupoNumeros = arr[i][1];
              let numerosBolaoSimples = [];
              for (var j = 0; j < grupoNumeros.length; j++) {
                numerosBolaoSimples.push(grupoNumeros[j].numero);
              }
              this.bolao.numeros.push({
                sequencialbolao: arr[i][0],
                numeros: numerosBolaoSimples,
              });
            }
          }
        } else {
          this.bolao.regras = this.configuracoesBolao.regras;
          this.bolao.numeros = [];
          this.bolao.status = "A";
        }
        this.createRules();
      } else {
        this.resetForm();
        this.editedBolao = null;
        this.bolao.numeros = [];
        this.comprasUsers = [];
        console.log();
      }
    },
    dialogSettings(v) {
      if (v) {
        this.getSettingsBolao();
      }
    },
    dtInicial(v) {
      this.replaceRegras();
    },
    dtFinal(v) {
      this.replaceRegras();
    },
    "bolao.numeroconcurso"() {
      this.replaceRegras();
    },
    "bolao.tipo"() {
      this.replaceRegras();
      this.getTodosBoloesArmazenados();
    },
    "bolao.horalimite"() {
      this.replaceRegras();
    },
    "bolao.valor"() {
      this.replaceRegras();
    },
    "bolao.qtdemaxquotas"() {
      this.replaceRegras();
    },
    "bolao.qtdenumeroaposta"() {
      this.replaceRegras();
    },
    "bolao.qtdebolaoaleatorio"(v) {
      if (this.bolao.id == null) {
        this.bolao.numeros = [];
        let seq = this.configuracoesBolao.sequencial;
        let max = seq + parseInt(v) - 1;
        for (var i = seq; i <= max; i++) {
          let bolaoNumero = { sequencialbolao: i, numeros: [] };
          this.bolao.numeros.push(bolaoNumero);
        }
      }
    },
    "bolao.valortotalpremio"(value) {
      this.bolao.valorpremioaposta = value / this.bolao.qtdemaxquotas;
    },
  },
  created() {
    this.getDadosBolao();
  },

  methods: {
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    },
    createRules() {
      this.numeroRules = [(v) => !!v || "Número concurso é obrigatório"];
      this.numeroLoteriaRules = [(v) => !!v || "Número Loteria é obrigatório"];
      this.tipoRules = [(v) => !!v || "Tipo é obrigatório"];
      this.statusRules = [(v) => !!v || "Status é obrigatório"];
      this.qtdeBoloesRules = [(v) => !!this.validateQtdeBolao(v) || "Qtde bolao é obrigatório"];
      this.valorRules = [(v) => !!v || "Valor é obrigatório"];
      this.qtdeQuotasRules = [(v) => !!v || "Qtde Quotas é obrigatório"];
      this.dtInicioRules = [
        (v) => !!v || "Data Inicial é obrigatório",
        (v) => Util.isValidDate(v) || "Data inválida",
      ];
      this.dtfinalRules = [
        (v) => !!v || "Data Final é obrigatório",
        (v) => Util.isValidDate(v) || "Data inválida",
      ];
      this.horaLimiteRules = [(v) => this.validateHoraLimite(v) || "Hora inválida"];
      this.qtdeNumerosRules = [(v) => !!v || "Qtde de números é obrigatório"];
      this.percSupremoRules = [
        (v) =>
          this.validatePercentualSupremo(v) ||
          "Percentual Bolão supremo é obrigatório!",
      ];
      this.minimoSupremoRules = [
        (v) =>
          this.validatePercentualSupremo(v) ||
          "Minimo de números é obrigatório!",
      ];
      this.valorTotalPremioRules = [
        (v) =>
          this.validateValorTatalPremio(v) ||
          "Valor total do prêmio é obrigatório!",
      ];
    },
    onChangeBolaoArmazenado(value){
      this.bolaoArmazenadoSelecionado = value;
      for(var i = 0; i< value.sequenciaisBoloesArmazenados.length; i++){
        this.bolao.numeros[i].sequencialbolao = value.sequenciaisBoloesArmazenados[i].sequencial;
        for(var j =0 ; j < value.sequenciaisBoloesArmazenados[i].numerosBoloesArmazenados.length; j ++){
          this.bolao.numeros[i].numeros.push(value.sequenciaisBoloesArmazenados[i].numerosBoloesArmazenados[j].numero);
        }
      }
    },
    imprimirNumeros(){
      this.$store
        .dispatch("getRelatorioBolaoArmazenado", this.bolaoArmazenadoSelecionado.id)
        .then((value) => {
          var byteCharacters = atob(value);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf;base64" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text:
              "Ouve um erro ao processar sua solicitação! Tente novamente mais tarde.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeConcurso(value) {
      this.bolao.concursovinculado = value.id;
      this.numerosSorteados = [];
      let numerosConcurso = [];
      for (var i = 0; i < value.numeros.length; i++) {
        numerosConcurso.push(value.numeros[i].numero);
      }
      for (var i = 0; i < this.bolao.numeros.length; i++) {
        for (var j = 0; j < this.bolao.numeros[i].numeros.length; j++) {
          var numeroBolao = this.bolao.numeros[i].numeros[j];
          let nSorteado = numerosConcurso.filter(function(v) {
            return v == numeroBolao;
          });
          if (nSorteado.length > 0) {
            this.numerosSorteados.push(nSorteado[0]);
          }
        }
      }
      if (this.numerosSorteados.length >= 11) {
        if (
          this.numerosSorteados.length >= 11 &&
          this.numerosSorteados.length <= 13
        ) {
          var numeroAcertos = this.numerosSorteados.length;
          var premioIndividual = this.configuracoesBolao[
            "premio" + numeroAcertos + "_bolao" + this.bolao.qtdenumeroaposta
          ];
          if (this.bolao.apostasefetivadas > 0) {
            this.bolao.valortotalpremio =
              this.bolao.qtdemaxquotas * premioIndividual;
          }
          this.bolao.valorpremioaposta = premioIndividual;
          this.bolaoPremioKey += 1;
        } else {
          this.$store.dispatch("setNotification", {
            type: "info",
            text:
              "Bolão sorteado com " + this.numerosSorteados.length + " números",
          });
        }
        this.bolao.premiado = true;
        this.bolao.pontosacertados = this.numerosSorteados.length;
      } else {
        this.bolao.premiado = false;
        this.bolao.valorpremioaposta = 0;
        this.bolao.pontosacertados = null;
        this.bolao.valortotalpremio = 0;
      }
      console.log();
    },
    getConcursos() {
      var tipo = "";
      if (this.bolao.tipo == "loto") {
        tipo = "lotofacil";
      } else if (this.bolao.tipo == "sena") {
        tipo = "megasena";
      }
      this.loading = true;
      this.$store
        .dispatch("fetchConcursosLotoFacil", tipo)
        .then((value) => {
          this.concursos = value;
          var cv = this.bolao.concursovinculado;
          if (cv) {
            let c = this.concursos.filter(function(v) {
              return v.id == cv;
            });
            if (c.length > 0) this.concursoSelecionado = c[0];
          }
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os boloes",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDadosBolao() {
      this.loading = true;
      this.$store
        .dispatch("getDadosBolao", this.filtro)
        .then((value) => {
          this.boloesKey += 1;
          this.boloes = value;
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os boloes",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSettingsBolao() {
      this.loadingSettings = true;
      this.$store
        .dispatch("getSettingsBolao")
        .then((value) => {
          if (value) {
            this.configuracoesBolao = value;
            if (this.bolao.id == null) {
              this.bolao.regras = this.configuracoesBolao.regras;
            }
          } else this.configuracoesBolao = {};
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os boloes",
          });
        })
        .finally(() => {
          this.loadingSettings = false;
        });
    },
    getDadosUsuarios(idBolao) {
      this.loading = true;
      this.$store
        .dispatch("getDadosUsuarios", idBolao)
        .then((value) => {
          this.comprasUsers = value;
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os boloes",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buscarBoloesArmazenados(){
      if(this.bolao.qtdenumeroaposta == null){
         this.$store.dispatch("setNotification", {
            type: "error",
            text: "Selecione a quantidade de números no bolão",
          });

      }else if(this.bolao.tipo == null){
         this.$store.dispatch("setNotification", {
            type: "error",
            text: "Selecione o tipo do bolão",
          });
        
      }else if(this.bolao.qtdebolaoaleatorio == null){
         this.$store.dispatch("setNotification", {
            type: "error",
            text: "Selecione a quantidade de bolões",
          });        
      }else{   
        if(this.bolaoArmazenadoweFiltro){
          this.getBoloesArmazenadosByDescricao(this.bolaoArmazenadoFiltro, this.bolao.qtdenumeroaposta, this.bolao.qtdebolaoaleatorio, this.bolao.tipo);
        }else{
          this.getBoloesArmazenados(this.bolao.qtdenumeroaposta, this.bolao.qtdebolaoaleatorio, this.bolao.tipo);
        }
      }
    },
    getTodosBoloesArmazenados(){
      if(this.bolao.qtdebolaoaleatorio!= null && this.bolao.qtdebolaoaleatorio!= 0 &&
         this.bolao.tipo != null && this.bolao.qtdenumeroaposta != null && this.bolao.qtdenumeroaposta != 0){
           this.getBoloesArmazenados(this.bolao.qtdenumeroaposta, this.bolao.qtdebolaoaleatorio, this.bolao.tipo);
         }
    },
    getBoloesArmazenados(qtdeNumeros, qtdeBoloes, tipo) {
      this.loading = true;
      this.$store
        .dispatch("getBoloesArmazenados", {qtdeNumeros, qtdeBoloes, tipo})
        .then((value) => {
          this.boloesArmazenados = value;
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBoloesArmazenadosByDescricao(descricao, qtdeNumeros, qtdeBoloes, tipo) {
      this.loading = true;
      this.$store
        .dispatch("getBoloesArmazenadosByDescricao", {descricao, qtdeNumeros, qtdeBoloes, tipo})
        .then((value) => {
          this.boloesArmazenados = value;
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loading = false;
        });
    },
    salvarBolaoArmazenado(){
      if(this.bolao.qtdenumeroaposta == null || this.bolao.qtdenumeroaposta == 0){
        this.$store.dispatch("setNotification", {
              type: "error",
              text: "Informe a quantidade de numeros na aposta",
            });
      }else 
      if(this.nomeCombinacao != null && this.nomeCombinacao != ''){
        this.loading = true;
        
      let payload  = {
            descricao: this.nomeCombinacao,
            qtdeNumeros: this.bolao.qtdenumeroaposta,
            qtdeBoloes: this.bolao.qtdebolaoaleatorio,
            tipo: this.bolao.tipo,
            sequenciaisBoloesArmazenados: []
          };

        for(var i=0; i< this.bolao.numeros.length; i++){
          let bolaoSequencial = {
            sequencial: this.bolao.numeros[i].sequencialbolao, 
            numerosBoloesArmazenados: []
          };
          for(var j = 0; j< this.bolao.numeros[i].numeros.length; j++){
            bolaoSequencial.numerosBoloesArmazenados.push({numero: this.bolao.numeros[i].numeros[j]});
          }
          payload.sequenciaisBoloesArmazenados.push(bolaoSequencial);
        }
        console.log(payload);

        this.$store
          .dispatch("saveBolaoArmazenado", payload)
          .then((value) => {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: "Combinação de números salva com sucesso!",
            });
          })
          .catch((err) => {
           this.$store.dispatch("setNotification", {
              type: "error",
              text: err,
            });
          })
          .finally(() => {
            this.loading = false;
          });

      }else{
        this.$store.dispatch("setNotification", {
              type: "error",
              text: "Informe a descrição da combinação",
            });
      }

    },
    incluirBolao() {
      this.bolao = {};
      this.editedBolao = null;
      this.dialog = true;
    },
    onClickSettings() {
      this.dialogSettings = true;
    },
    onSaveSettings() {
      this.dialogSettings = false;
      this.$store
        .dispatch("saveSettingsBolao", this.configuracoesBolao)
        .then((value) => {
          if (value.type == "error") {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: value.msg,
            });
          } else {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: value.msg,
            });
            this.dialog = false;
            this.getDadosBolao();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.updateLoading = false;
        });
    },
    replaceRegras() {
      if (this.configuracoesBolao && this.configuracoesBolao.regras) {
        let regras = this.configuracoesBolao.regras;
        if (this.bolao.numeroconcurso) {
          regras = regras.replaceAll("[numero]", this.bolao.numeroconcurso);
        }
        if (this.bolao.horalimite) {
          regras = regras.replaceAll("[hora]", this.bolao.horalimite);
        }
        if (this.dtInicial != "") {
          regras = regras.replaceAll("[dataInicial]", this.dtInicial);
        }
        if (this.dtFinal != "") {
          regras = regras.replaceAll("[dataFinal]", this.dtFinal);
        }
        if (this.bolao.tipo) {
          regras = regras.replaceAll(
            "[tipo]",
            this.bolao.tipo == "sena" ? "Mega Sena" : "Loto Fácil"
          );
        }
        if (this.bolao.valor) {
          regras = regras.replaceAll("[valor]", this.bolao.valor);
        }
        if (this.bolao.qtdemaxquotas) {
          regras = regras.replaceAll(
            "[qtdemaxquotas]",
            this.bolao.qtdemaxquotas
          );
        }
        if (this.bolao.qtdenumeroaposta) {
          regras = regras.replaceAll(
            "[qtdenumeroaposta]",
            this.bolao.qtdenumeroaposta
          );
        }

        this.bolao.regras = regras;
      }
    },
    onSave() {
      if (this.validateForm()) {
        this.bolao.datainicio = this.dtInicial;
        this.bolao.datafinal = this.dtFinal;
        var numerosCorretos = true;
        for (var b of this.bolao.numeros) {
          if (this.bolao.qtdenumeroaposta > b.numeros.length) {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: "Selecione " + this.bolao.qtdenumeroaposta + " números",
            });
            numerosCorretos = false;
            break;
          } else if (this.bolao.qtdenumeroaposta < b.numeros.length) {
            this.$store.dispatch("setNotification", {
              type: "error",
              text:
                "Selecione somente" + this.bolao.qtdenumeroaposta + " números",
            });
            numerosCorretos = false;
            break;
          }
        }

        if (numerosCorretos) {
          if (this.bolao.status == "E") {
            this.bolao.dtFinal = new Date();
          }
          this.$store
            .dispatch("saveBolao", this.bolao)
            .then((value) => {
              if (value.type == "error") {
                this.$store.dispatch("setNotification", {
                  type: "error",
                  text: value.msg,
                });
              } else {
                this.$store.dispatch("setNotification", {
                  type: "success",
                  text: value.msg,
                });
                this.dialog = false;
                this.getDadosBolao();
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.updateLoading = false;
            });
        }
      }
    },

    validateForm() {
      if (this.$refs.bolaoForm.validate()) {
        return true;
      }
      return false;
    },
    resetForm() {
      console.log("reset form");
      if (this.$refs.bolaoForm) {
        this.$refs.bolaoForm.reset();
        this.dtInicial = "";
        this.dtFinal = "";
      }
    },
    editItem(item) {
      this.editedBolao = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteDialog = true;
    },
    onConfirmDelete(id) {
      this.deleteDialog = false;
      this.$store
        .dispatch("removeBolao", id)
        .then((value) => {
          this.$store.dispatch("setNotification", {
            type: "success",
            text: value.msg,
          });
          this.getDadosBolao();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os boloes",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    formatStatus(status) {
      if (status == "S") {
        return "Solicitado";
      } else if (status == "E") {
        return "Enviado";
      } else if (status == "P") {
        return "Pago";
      }
      return "";
    },
    gerarCombinacoes() {
      
      for (var b of this.bolao.numeros) {
        do {
          let num = this.generateRandomInteger();
          if (!b.numeros.includes(num)) {
            b.numeros.push(num);
          }
        } while (b.numeros.length < this.bolao.qtdenumeroaposta);
      }
      this.combinacoesGeradas = true;
    },
    generateRandomInteger() {
      let min = 1;
      let max = this.bolao.tipo == "loto" ? 25 : 60;
      return Math.floor(min + Math.random() * (max + 1 - min));
    },
    validatePercentualSupremo(v) {
      if ((this.bolao.id == null) && (this.bolao.supremo && (v == null || v == 0))) {
        return false;
      }
      return true;
    },
    validateValorTatalPremio(v) {
      if (this.bolao.premiado && (v == null || v == 0)) {
        return false;
      }
      return true;
    },
    validateHoraLimite(v) {
      if (Util.isValidTime(v) || this.bolao.status == 'E'){
        return true;
      }
      return false;    
    },
    validateQtdeBolao(v){
      if (v != null || this.bolao.status == 'E'){
        return true;
      }
      return false;
    }
  },
};
</script>
